import * as d3 from 'd3';
export class Histogram {

    private _histogramGroup: d3.Selection<any>;
    private _histogram: d3.layout.Histogram<any>;
    private _histogramScale: d3.scale.Linear<number, number>;
    private _yScale: d3.scale.Linear<number, number>;
    private _bandHeight: number;
    private _data: any[];

    private _binsCount = 50;

    constructor(container: d3.Selection<any>, width: number, height: number) {
        if (isNaN(width)) {
            width = 0;
        }
        if (isNaN(height)) {
            height = 0;
        }
        this.init(container, width, height);
    }

    private init(container, width: number, height: number) {
        this._histogram = d3.layout.histogram()
            .bins(this._binsCount)
            .value((d: any) => d.value);
        this._histogramScale = d3.scale.linear()
            .range([0, width / 4]);
        this.setBandHeight(height);
        this._yScale = d3.scale.linear()
            .range([height, 0]);
        this._histogramGroup = container.append('g')
            .classed('histogram-group', true);
    }

    update(data: any[]) {
        this._originalData = data;
        const binned = this._histogram(data);
        this._histogramScale.domain([0, d3.max(binned, b => b.length)]);
        this._data = binned;
        const histDataBound = this._histogramGroup.selectAll('.bin')
            .data(binned);
        histDataBound.exit()
            .remove();
        histDataBound.enter()
            .append('rect')
            .classed('bin', true);
        this.render();
    }

    resize(width: number, height: number) {
        this._histogramScale.range([0, width / 4]);
        this._yScale.range([height, 0]);
        this.setBandHeight(height);
        this.render();
    }

    updateRange(extent: [number, number]) {
        this._histogram.range(<any>extent);
        this._yScale.domain(extent);
        if (this._data) {
            this.update(this._originalData);
        }
    }

    private render() {
        this._histogramGroup
            .selectAll('.bin')
            .attr({
                'y': (d, i) => {
                    return this._yScale(d.x) - this._bandHeight;
                },
                'width': d => this._histogramScale(d.length),
                'height': this._bandHeight
            });
    }

    private setBandHeight(height: number) {
        this._bandHeight = height / this._binsCount;
    }

    private _originalData: any[];
}